import React from 'react';
import { Typography, Button } from '@material-ui/core';

import { addBaseName } from '../../helpers';

type Props = {
  children: React.ReactNode;
};

type State = {
  error: Error | null;
};

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error) {
    // TODO: track error
    this.setState({ error });
  }

  reload = () => {
    this.setState({ error: null });
  };

  render() {
    const { children } = this.props;
    const { error } = this.state;

    if (error) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            fontFamily: 'roboto',
            color: '#fff',
            background:
              'linear-gradient(22deg, rgba(68,45,176,1) 35%, rgba(107,86,214,1) 100%)',
          }}>
          <div style={{ padding: '16px' }}>
            <h1 style={{ fontSize: '45px' }}>OOPS!</h1>
            <h3 style={{ fontSize: '30px' }}>
              Something went wrong, please reload the application
            </h3>
            <Button
              variant='outlined'
              color='primary'
              style={{ backgroundColor: '#fff' }}
              onClick={() => window.location.reload()}>
              Reload application
            </Button>
          </div>
        </div>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
